module.exports = __webpack_public_path__ + "img/goal-10.0c433188.png";